<template>
  <div class="step">
    <el-row class="row-box">
      <!-- wait / process / finish / error / success el-step__icon-inner -->
      <el-steps :active="activeStep" simple :space="62" process-status="finish" finish-status="wait " class="wrapper">
        <el-step index=""  :title="languageDataObj.step.projectdetail[language]" icon="el-icon-postcard" class="item" style="flex-basis:25%;"></el-step>
        <el-step :title="languageDataObj.step.resume[language]" icon="el-icon-tickets" class="item" style="flex-basis:25%;"></el-step>
        <!-- <el-step title="alent recommendation" icon="el-icon-user" class="item"></el-step> -->
        <!-- <el-step title="Talent evaluation" icon="el-icon-edit-outline" class="item"></el-step> -->
      </el-steps>
      <div class="linkBox">
        <router-link to='/xqpositionmanagement/positiondetail' class="links" tag='div'></router-link>
        <router-link to='/xqpositionmanagement/positionresume' class="links" tag='div'></router-link>
        <!-- <router-link to='/xqpositionmanagement/index' class="links" tag='div'></router-link> -->
        <!-- <router-link to='/xqpositionmanagement/peopleevaluation' class="links" tag='div'></router-link> -->
      </div>
    </el-row>
  </div>
</template>

<script>
import mixin from '@/mixin/mixin';
export default {
  name: "Step",
  mixins:[mixin],
  props:{
    step:{
      type:Number,
      required:true,
    }
  },
  data() {
    return {
      activeStep:0,
      // language
      languageDataObj:null,
    };
  },
  watch:{
    // 监听语言变化,并进行回调
    language:function (val, oldVal) {
      this.backLanguageText('XQPositionAll') 
    },
  },
  mounted(){
    this.activeStep = this.step;
  },
  computed:{
    // 计算监听数据
    language(){
      return this.$store.state.languageType
    }
    // 获取路由导航
    // getPath(){
    //   return this.$store.state.sidePath
    // }
  },
  created(){
    this.backLanguageText('XQPositionAll') 
  },
  methods:{

  }
};
</script>
<!-- is-finish is-process -->
<style lang="less">

</style>
<style lang="less" scoped>
.step {
  height: 4rem;
  background: #ffffff;
  border-radius: 0.75rem;
  font-family: Arial, Helvetica, sans-serif;
  .wrapper {
    height: 4rem;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 1.5rem;
    border-radius: 0.75rem;
    font-size: 0.75rem;

    .item {
      cursor: pointer;
      font-weight: bold;
      // background-color: #c00;
    }
  }
  .row-box{
    position: relative;
    .linkBox{
      position: relative;
      top: -48px;
      // float: left;
      height: 30px;
      width: auto;
      // background-color: rgb(235, 120, 120);
      display: flex;
      // justify-content: space-between;
      align-items: center;
      .links{
        width: 260px;
        height: 30px;
        // background-color: rgb(167, 241, 29);
      }
    }
  }
}

/deep/
  .el-step.is-simple
  .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 24px;
}
/deep/ .el-step{
  .el-step__title{
    min-width: 150px;
    font-size: 15px;
    // background-color: #c00;
  }
  &.item{
    flex-basis:30%;
  }
  .el-step__arrow{
    max-width: 100px;
  }
}
/deep/ .el-step.is-simple:not(:last-of-type) .el-step__title{
  max-width: 60%;
}
</style>